import { flatten, sortBy } from "lodash";
import { createSelector } from "reselect";

import { ITechnician, IState } from "./model";

export const selectTechnicians = createSelector<
  { technicians: IState },
  ITechnician[],
  ITechnician[]
>(
  ({ technicians }: { technicians: IState }) => technicians.items,
  (items) =>
    items.map((item) => ({
      ...item,
    }))
);



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/technicians/selectors.ts